module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": "",
      "sm12": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-center"
  }, _vm._l((_vm.skills), function(skill) {
    return _c('v-chip', {
      key: skill.name
    }, [_vm._v("\n          " + _vm._s(skill.name) + "\n        ")])
  }))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-574dec39","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Topics.vue
// module id = 830
// module chunks = 1